import { render } from "./template.vue?vue&type=template&id=66b221f0&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=66b221f0&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b221f0"]])

export default __exports__